import React, { useEffect, JSX } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { routeChangeEvent, SessionStorage, SessionStoragePersistence } from '@ibe/services';
import { SessionStorageType } from './Components/Search';
import { productSearchSessionKey } from './Config/sessionkeys';
import { BOOKINGID_STORAGE_KEY } from './Util/constant';
import { stepSessionStorage } from './Util/globals';
import { useExternalSearchParams } from '@ibe/components';
import PageUrl from './Models/PageUrl';

const RouteBroadcast = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname, search } = location;
  const sessionStorage = new SessionStorage<SessionStorageType>(productSearchSessionKey);
  const context = useExternalSearchParams();

  useEffect(() => {
    const urlObject = new URL(`${location.pathname}${location.search}`, window.location.origin);
    if (!urlObject.searchParams.get('fromOnPopstate')) {
      window.history.pushState({ url: `${urlObject.pathname}${urlObject.search}` }, '');
    }
  }, [location]);

  useEffect(() => {
    const callback = (evt: PopStateEvent) => {
      const urlObject = new URL(window.location.origin);
      urlObject.searchParams.append('fromOnPopstate', 'true');
      const bidSessionStorage = new SessionStoragePersistence<string>();
      bidSessionStorage.useKey(context?.widgetSessionKeyPrefix + BOOKINGID_STORAGE_KEY);
      if (bidSessionStorage.exists()) {
        stepSessionStorage.set('confirmation');
        navigate(PageUrl.CHECKOUT + '/confirmation');
        return;
      }
      if (!!sessionStorage.get()?.search && evt.state == null) {
        sessionStorage.clear();
        navigate(`${urlObject.pathname}${urlObject.search}`);
      } else if (evt.state) {
        const newUrl = evt.state?.url;
        const urlObjectTemp = new URL(newUrl, window.location.origin);
        urlObjectTemp.searchParams.append('fromOnPopstate', 'true');
        navigate(`${urlObjectTemp.pathname}${urlObjectTemp.search}`);
      } else {
        navigate(`${urlObject.pathname}${urlObject.search}`);
      }
    };

    window.addEventListener('popstate', callback);

    return () => {
      window.removeEventListener('popstate', callback);
    };
  }, []);

  useEffect(() => {
    routeChangeEvent.broadcast(location);
  }, [pathname, search]);

  return <></>;
};

export default RouteBroadcast;
